$(document).ready(function () {

    jQuery(function ($) {
        const MyMapA = [
            {
                province: 'Tehran', city: 'Tehran', company: 'Rahravan Sepehr Andisheh',
                address: 'Tehran – Beheshti St. – After Ghaem Maqam Farahani Crossroads – No. 436 – Parse Building – 4th Floor – Unit 16',
                phone: '02188102351',
                lat: 35.72800748406994,
                lng: 51.41715650711837,
            },
        ];
        createMapIframe({
            container: '#map-a',
            data: MyMapA,
            className: 'map-embed is-large',
            height: '420px',
        });
    });



    jQuery(function ($) {
        // چندنقطه
        const MyMapB = [
            {
                province: 'East Azerbaijan', city: 'Tabriz', company: 'Ra Ravan Mehregan Sarzamin',
                address: 'Tabriz – Chaykenar – Dimashqieh Street – Engineers Building – 3rd Floor – Unit C',
                phone: '0914-6600678, 041-33376792',
                lat: 38.07421142270715,
                lng: 46.313855824560704,
                color: '#2876d6'
            },

            {
                province: 'Ardabil', city: 'Ardabil', company: 'Arta Power Network Providers',
                address: 'Ardabil – Enghelab Street – Opposite Mansourieh Mosque',
                phone: '0914-9512953, 045-33257789',
                lat: 38.25257761396088,
                lng: 48.28924689047375,
                color: '#2876d6'
            },

            {
                province: 'Busheh', city: 'Borazjan', company: 'Khard No Andish',
                address: 'Busheh – Borazjan – Shahid Chamran Street – Saman Commercial Complex – 1st Floor – Unit 40',
                phone: '077-34229591, 0917-3786058',
                lat: 29.266363170111973,
                lng: 51.2074308547881,
                color: '#2876d6'
            },

            {
                province: 'Khorasan Razavi', city: 'Mashhad', company: 'Ra Ravan Mehregan Sarzamin',
                address: 'Mashhad – Sanaei Street – Saheb-e-Zaman Square – Sobhan Commercial Complex – 2nd Floor Office – Unit 213',
                phone: '0915-2942666, 051-37133258-9',
                lat: 36.2991169477131,
                lng: 59.59799393133687,
                color: '#2876d6'
            },

            {
                province: 'North Khorasan', city: 'Esfarayen', company: 'Pajhwok Electronic East',
                address: 'North Khorasan – Esfarayen – Taleghani Street – Next to the Telecommunications Department',
                phone: '0912-2276552, 058-37242440',
                lat: 37.081745593075354,
                lng: 57.51516820344713,
                color: '#2876d6'
            },

            {
                province: 'South Khorasan', city: 'Birjand', company: 'Nikab Khavaran',
                address: 'Birjand – Pasdaran Street – Corner of Pasdaran 19 – No. 53',
                phone: '0915-1634176, 056-32423719',
                lat: 32.8500657928046,
                lng: 59.22213063140421,
                color: '#2876d6'
            },

            // سه ردیف زیر آدرس «تهران» دارند (برای نمایندگی‌های استانی شما).
            {
                province: 'Tehran', city: 'Tehran', company: 'Rahravan Sepehr Andisheh',
                address: 'Tehran – Beheshti St. – After Ghaem Maqam Farahani Crossroads – No. 436 – Parse Building – 4th Floor – Unit 16',
                phone: '02188102351',
                lat: 35.72800748406994,
                lng: 51.41715650711837,
                color: '#c23c3a'
            },

            {
                province: 'Semnan', city: 'Semnan', company: 'Ra Ravan Mehregan Sarzamin',
                address: 'Tehran – Beheshti St. – After Ghaem Maqam Farahani Crossroads – No. 436 – Parse Building – 4th Floor – Unit 16',
                phone: '0912-8177521, 021-88102351-5',
                lat: 35.58449286813622,
                lng: 53.386542412481674,
                color: '#2876d6'
            },

            {
                province: 'Sistan and Baluchestan', city: 'Sistan and Baluchestan', company: 'Ra Ravan Mehregan Sarzamin',
                address: 'Tehran – Beheshti St. – After Ghaem Maqam Farahani Crossroads – No. 436 – Parse Building – 4th Floor – Unit 16',
                phone: '0912-8177521, 021-88102351-5',
                lat: 28.219642875330464,
                lng: 61.21333991782359,
                color: '#2876d6'
            },

            {
                province: 'Qazvin', city: 'Qazvin', company: 'Atlas Niroo Mehr',
                address: 'Qazvin – West Bu Ali Street – Between Anari and Nizam Vafa Crossroads – Corner of Tafreshi Alley',
                phone: '0912-3820240, 028-33333515',
                lat: 36.30514338881183,
                lng: 50.01453871139611,
                color: '#2876d6'
            },

            {
                province: 'Kurdistan', city: 'Dehgolan', company: 'Electrofanos Alvand',
                address: 'Dehgolan – Mohammad Oraz Street – Opposite Social Security',
                phone: '0918-1117357, 087-5125849',
                lat: 35.27611934924158,
                lng: 47.41434582114775,
                color: '#2876d6'
            },

            {
                province: 'Kerman', city: 'Kerman', company: 'Shayan Barg Karmania',
                address: 'Kerman – Khazra Industrial Park No. 2 – Pamchal Blvd – Street 15',
                phone: '0913-1412794, 034-33386347',
                lat: 30.261108417386822,
                lng: 57.11252483861102,
                color: '#2876d6'
            },

            {
                province: 'Markazi', city: 'Arak', company: 'Electrofanos Alvand',
                address: 'Arak – Government Square – Farmanieh Complex – 4th Floor – Unit 13',
                phone: '0918-1113557, 086-34021396',
                lat: 34.07101037342822,
                lng: 49.77540803888178,
                color: '#2876d6'
            },

            {
                province: 'Hamdan', city: 'Hamdan', company: 'Electrofanos Alvand',
                address: 'Hamdan – Khajeh Rashid Blvd – Parsian Building – 3rd Floor – Unit 14',
                phone: '0918-1117357, 081-38273796-7',
                lat: 34.77729768751017,
                lng: 48.5078933596495,
                color: '#2876d6'
            },

            {
                province: 'Yazd', city: 'Yazd', company: 'Kavian Sanat',
                address: 'Yazd – Modares Blvd – Opposite Social Security',
                phone: '0913-2517132, 035-38273412, 035-38263883',
                lat: 31.87974409566442,
                lng: 54.39251202955373,
                color: '#2876d6'
            },
        ];
        createMapIframe({
            container: '#map-b',
            data: MyMapB,
            className: 'map-embed is-large',
            features: { filterProvince: true, filterCity: false, searchCompany: false },
            height: '500px',
        });
    });
});